import React, {useEffect} from 'react';
import {useRouter} from 'next/router';
import _ from 'lodash';

import Link from '../../components/Link';
import {FacebookButton, GoogleButton, LinkedInButton} from '../../components/SocialButton';

const SignupWall = ({onView = _.noop, onClick = _.noop}) => {
  const router = useRouter();
  const returnPath = router.asPath;

  useEffect(() => {
    onView();
  }, []);

  return (
    <div className="flex w-full py-12 px-8 border border-gray-200 rounded-lg bg-white">
      <div className="flex flex-col w-full">
        <h2 className="text-center text-2xl font-extrabold text-black">
          You&rsquo;re just one step away.
        </h2>
        <h3 className="text-lg text-center font-normal text-gray-500 mb-8">
          Create an account to get a free sample of our interview prep courses.
        </h3>
        <div className="flex flex-col mx-auto w-full max-w-sm space-y-2">
          <GoogleButton returnPath={returnPath} onClick={() => onClick('google')}>
            Sign up with Google
          </GoogleButton>
          <FacebookButton returnPath={returnPath} onClick={() => onClick('facebook')}>
            Sign up with Facebook
          </FacebookButton>
          <LinkedInButton returnPath={returnPath} onClick={() => onClick('linkedin')}>
            Sign up with LinkedIn
          </LinkedInButton>
          <Link
            href={`/login?returnPath=${returnPath}`}
            className="text-indigo text-center font-medium p-2"
            onClick={() => onClick('login')}
          >
            Or login to your account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignupWall;
